module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_History_16"],"path":[{"$":{"d":"M16,15l-1.79-1.84A8,8,0,0,1,0,8,7.93,7.93,0,0,1,8,0a8,8,0,0,1,7.29,4.42C11.91,2,10.54,1.5,8.05,1.5a6.45,6.45,0,1,0,5,10.48l-2-2h5ZM5.21,3.91,3.93,5l4.16,4.8L11.68,7l-1-1.34L8.31,7.49Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_History_16.svg
// module id = mVkU
// module chunks = 1